
import React, { useState } from "react";
import { ReactComponent as ArrowRight } from './reshot-icon-arrow-left-4NA6KJF8CU.svg';
import { ReactComponent as ArrowLeft } from './reshot-icon-arrow-right-ZP2WDL9B8N.svg';
import automatedCalendarImage from './images/Events.png';
import googleAiImage from './images/Googleai.png';
import womenStem from './womenStem.png';
import socalFurspng from './images/SocalFursUpdated.png'
import jewelry from './Screenshot 2025-05-08 at 9.59.35 AM.png'
import SI from "./images/SI Auto Tracker.png"
import socalfurimage from "./socal.png";
import { Link } from "react-router-dom";
import { ReactComponent as Icon1 } from './svg/python-svgrepo-com.svg';
import { ReactComponent as Icon2 } from './svg/react-svgrepo-com.svg';
import CodeSocal from "./components/CodeSocal.jsx"
import CodeSocal2 from "./components/CodeSocal2.jsx";
import reddit from "../pages/Reddit.png"
import './ProjectPage.css';
import SocialGroupLinkButton from "./components/SocialGroupLinkButton.jsx";
import EventMapPage from './EventMapPage.jsx'
import ExpandedEvent from "./components/ExpandedEvent.jsx";
import CalendarPage from "./CalendarPage.jsx";


const Carousel = ({ data }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    if (slide === data.length - 1) 
    {
      setSlide(0);
    } else 

    {
      setSlide(slide + 1);
    }
  };
  
  const prevSlide = () => {
    if (slide === 0) {
      setSlide(data.length - 1);
    } else 
    
    {
      setSlide(slide - 1);
    }
  };

  return (
    <div className="carousel">
      <ArrowLeft onClick={prevSlide} className="arrow arrow-left" />
      {data.map((item, idx) => {
        return (
          <img
            src={item.src}
            alt={item.alt}
            key={idx}
            className={slide === idx ? "slide" : "slide slide-hidden"}
          />
        );
      })}
      <ArrowRight
        onClick={nextSlide}
        className="arrow arrow-right"
      />
      <span className="indicators">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};

export default function SocalFurs() {

  const data = [
    {src: socalFurspng, alt: "socalfurs.com"},
    { src: automatedCalendarImage, alt: "Automated Calendar" },
    { src: googleAiImage, alt: "Automated Calendar" },
  ];

  const data2 =[
    { src: jewelry, alt: "Jewelry" }
  ];


  const data3 = [
    {src: SI, alt: "Student Tracking"}
  ];

  return (

    <div className="App">
     
          
        <div className = "home-page-container">
          
       

          <div className = "green-line-bottom"> 
       
            <div className = "link-container">
                  <heading style = {{fontSize:28}}className = "header-avry2">Freelance/Project: <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href = "https://socalfurs.com">Socalfurs.com</a> </heading>

              </div> 


      
         
          </div>
      
              {/* Carousel Component */}
                
                <div className = "container-carousel">

                 
                    <Link to = "https://socalfurs.com/"><img style ={{height:"200px",width:"200px",padding:"10px"}}src={socalfurimage}></img></Link>
                {/* <a className = "project-github" href = "https://avryjacksoncom.github.io">Project Notes</a> */}
                    <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}to = "https://github.com/avryjacksoncom/FurryCalendarApiRepo"><h3>Github Repo</h3> </Link>
                 <p  className = "paragraph-about-me-3">
               This project is a simple, automated tool designed to make browsing furry community events far easier and more accessible!
                For the longest time, most events were only announced through Telegram channels, which made it inconvenient to 
                check dates and locations especially while balancing college and work.
                To fix that, I built my own automated event-to-calendar system. It watches Telegram for new event posts, 
                extracts the important details, uses Google Gemini to interpret them, and then formats everything into a clean, 
                easy-to-read Google Calendar.
               
                </p>
                <p className = "paragraph-about-me-3">
                    After finishing the first version, I presented it to the head of 
                    SoCalFurs they absolutely loved it! Because of that, I now handle most of the development work 
                    for the group’s website as well. Which is awesome!
                </p>
                <p className = "paragraph-about-me-3">Now staying updated on upcoming events is effortless and the whole 
                    system is fully powered by something I built myself. And being used by a lot of people!
                  
                    </p>
                     

                  <div className = "header-avry">
                    
                  </div>
                  <heading style = {{fontSize: 30}}className = "header-avry2">Table Of Contents </heading>
                  <a><p></p></a>
                  <a href="#section1"><p style = {{ fontSize:30,color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className = "header-avry2">Automated Main Code</p></a>
                  <a href= "#section2"><p style = {{ fontSize:30,color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }} className = "header-avry2"r>Event Map Page</p></a>
                        <div className = "container-carousel">
                          <heading style = {{fontSize: 30}} className = "header-avry2">Reddit highlight</heading>
                                  <Link to = "https://www.reddit.com/r/furry/comments/1nazil7/finding_meet_ups_and_trying_to_make_new_friends/"><img className = "img-project" src = {reddit}></img></Link>
                        </div>
            
         

              {/* end of carousel compenent container */}
              </div>
              
                  <div className = "green-line-bottom"> 

                    
                  <p style = {{ color: "white", textDecoration: "None", textDecorationColor: "white" }}className = "header-avry2"> Automated Google Calendar
                </p>

              
                
              </div>
          <CalendarPage/>
            
        

       

                

           
               <div className = "green-line-bottom">
                <p></p>
                       <p className = "header-avry2">
                             <p id="section1" style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}className = "header-avry2"> Start Of Main Code:
                    </p>

                  <CodeSocal></CodeSocal>
             
                  
                </p>
          
                 </div>
                   <div className = "container-carousel">
                     <p id = "section2" style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}className = "header-avry2"> Event Map Page


                
                </p>
                <SocialGroupLinkButton type = "map"/>
                <p></p>
                     <p className = "paragraph-about-me-3">
     I partnered with another developer and we created an event map page
to be able to see where furry events are on a map. This feature was something
I wanted to create for a while, and we implemented it! You can view the event map above
on the deployed site by clicking the silly fox! Or view below!
                </p>
                        

                   </div>

                 
                              <EventMapPage></EventMapPage>
                      
                        
            
            <div className = "green-line-bottom">
                    
          <p className = "header-avry2">
            <p></p>
            <p></p>
                             <p className = "header-avry-6"> Event Page Handler:
                    </p>

                  <CodeSocal2></CodeSocal2>
                  
                </p>
            </div>
                   
              <div className = "container-carousel">

              </div>
        {/* Home-page-container div */}
        </div>

  
    {/* End of entire div */}
    </div>
  );
}
